<template>
    <div class="MembershipsView">
      <v-container fluid>
        <v-row>
          <v-col class="pa-0">
            <BannerTextComponent :image="require('@/assets/banners/banner00.png')" height="40vh" message="Eventos" />
          </v-col>
        </v-row>
        <v-row>
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Belleza
            </div>
            <ShowcaseComponent :items="$store.state.memberships.filter(item => item.country === 'CL')" />
          </v-col>
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Gourmet
            </div>
            <ShowcaseComponent :items="$store.state.memberships.filter(item => item.country === 'CL')" />
          </v-col>
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Panoramas
            </div>
            <ShowcaseComponent :items="$store.state.memberships.filter(item => item.country === 'CL')" />
          </v-col>
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Viajes
            </div>
            <ShowcaseComponent :items="$store.state.memberships.filter(item => item.country === 'CL')" />
          </v-col>
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Deporte
            </div>
            <ShowcaseComponent :items="$store.state.memberships.filter(item => item.country === 'CL')" />
          </v-col>
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
            Salud
            </div>
            <ShowcaseComponent :items="$store.state.memberships.filter(item => item.country === 'CL')" />
          </v-col>
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Otros
            </div>
            <ShowcaseComponent :items="$store.state.memberships.filter(item => item.country === 'CL')" />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="px-0">
            <SingleButtonParallaxComponent message="Compra tus puntos Passpoint y canjea tus Beneficios" button="Comprar Puntos" link="/" :background="require('@/assets/backgrounds/dominga.png')" />
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
import './_MembershipsView.scss'
import BannerTextComponent from '@/components/BannerTextComponent/BannerTextComponent.vue'
import SingleButtonParallaxComponent from '@/components/SingleButtonParallaxComponent/SingleButtonParallaxComponent.vue'
import ShowcaseComponent from '@/components/ShowcaseComponent/ShowcaseComponent'

export default {
  name: 'MembershipsView',
  components: { ShowcaseComponent, SingleButtonParallaxComponent, BannerTextComponent },
  data () {
    return {
      steps: [
        {
          title: 'Paso 1',
          message: 'Selecciona tu ticket en tu App'
        },
        {
          title: 'Paso 2',
          message: 'Escanea el punto de control'
        },
        {
          title: 'Paso 3',
          message: 'Disfruta el evento'
        }
      ]
    }
  }
}
</script>
